module.exports = __webpack_public_path__ + "img/youtube.6326daa2.svg";